var defaultImplementation = {
  format: function format(_format, value) {
    return value;
  },
  toString: function toString(value) {
    return value;
  },
  parseDate: function parseDate(value) {
    return new Date(value);
  }
};
var current = defaultImplementation;

var IntlService = function IntlService() {};

var staticAccessors = {
  implementation: {
    configurable: true
  }
};

IntlService.register = function register(userImplementation) {
  current = userImplementation;
};

staticAccessors.implementation.get = function () {
  return current;
};

Object.defineProperties(IntlService, staticAccessors);
export default IntlService;